// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3ARrn","inner":"style_inner__wmRMA","bottom":"style_bottom__NgOY1","copyright":"style_copyright__3uutU"};